const local = '_PROVIDER_DESCRICAO_DA_MISSAO_FOLLOWAIR_'
import Vue from 'vue'

var update = false

export default {
	methods: {
		_providerDescricaoDaMissao: function (callback) {
			this._httpGet('/Descricao_ordem_missao/lista', (retorno) => {
				if (retorno._request && retorno._status) {
					const listaDescricoes = retorno.lista.map((descricaoOrdemMissao) => {
						return descricaoOrdemMissao
					})
					callback(listaDescricoes)
				}
			})
		}
	}
}
